export const KT_ROW_CONTEXT = Symbol('KT_ROW_CONTEXT')
